import { ref } from 'vue'

const searchRef = ref('')
export function useProjectsData() {
	const search = searchRef

	return {
		search,
	}
}
